// src/components/auth/recovery/GetSupport.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../store/ThemeContext';
import { useCompanyConfig } from '../../../hooks/useCompanyConfig';
import styles from '../AuthPage.module.scss';
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import Spinner from '../../ui/spinners/Spinner';
import { getText } from '../../../i18n';

const GetSupport = () => {
    const navigate = useNavigate();
    const themeStyles = useTheme();
    const { isCompanyCodeReady, authData } = useCompanyConfig();

    const background = css`
        ${themeStyles?.loginBackground?.type === 'color'
            ? `background: ${themeStyles?.loginBackground?.color}`
            : `background-image: url(${themeStyles?.loginBackground?.image})`}
    `;

    const handleGetStarted = () => {
        const subject = `${authData?.companyCode} Login Support`;
        const body = `My name is:\nMy company is:\nMy work email is:\nHere's what I need help with:`;
        const mailtoLink = `mailto:app-support@ingaged.me?subject=${encodeURIComponent(
            subject,
        )}&body=${encodeURIComponent(body)}`;
        window.location.href = mailtoLink;
    };

    return (
        <div className={`${styles.container}`} css={background}>
            <div className="center-horizontal-and-vertical">
                <div className={`${styles.errorContainer} invisible`}>
                    <p className="text-danger"></p>
                </div>

                {!isCompanyCodeReady ? (
                    <div className="text-center">
                        <Spinner className={styles.loadingSpinner} width={50} />
                    </div>
                ) : (
                    <div
                        className={`${styles.authContainer} card modal-content`}
                    >
                        <div className="text-end">
                            <i
                                className="bi bi-x"
                                onClick={() => navigate(-1)}
                                style={{ cursor: 'pointer' }}
                            ></i>
                        </div>
                        <div
                            className={`${styles.companyCodeForm} text-center px-2 mx-4 form-container p-3`}
                        >
                            <div
                                className={`mb-4 iNGAGED-Primary-Color ${styles.envelope}`}
                            >
                                <i className="bi bi-envelope-open"></i>
                            </div>
                            <h2 className="iNGAGED-Typography-Heading3 mb-2">
                                {getText('msg_fe1a2922069b')}
                            </h2>
                            <p className="mb-4">
                                <i className="bi bi-envelope me-2 align-middle"></i>
                                {getText('msg_9163794e5fc6')}
                            </p>
                            <p className="mb-3">
                                {getText('msg_27b017ba7178')}
                            </p>
                            <p className="mb-3">
                                {getText('msg_c6a2e16541b1')}
                            </p>
                            <p className="mb-3">
                                {getText('msg_4c01e2af0e8e')}
                            </p>
                            <div className="form-group d-grid gap-2 col-10 mx-auto text-center pt-3">
                                <button
                                    className="ing-button-primary-left mx-auto mb-3"
                                    onClick={handleGetStarted}
                                    style={{
                                        backgroundColor:
                                            themeStyles?.primaryColor ||
                                            '#007bff',
                                    }}
                                >
                                    {getText('msg_bd2cb051773a')}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default GetSupport;
